let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5QVH4")).then(() => parcelRequire('dlAu1'));